import { SoapUtils } from "../../../utils/SoapUtils";

export interface Employee {
    id?:               string;
    contact?:          string;
    company?:          string;
    department?:       string;
    departmentInfo?:   string;
    position?:         string;
    positionInfo?:     string;
    isPrimary?:        string;
    validFrom?:        string;
    validTo?:          string;
    type?:             string;
    originalName?:     string;
    custom1?:          string;
    custom2?:          string;
    custom3?:          string;
    positionName?:     string;
    departmentName?:   string;
    name1?:            string;
    name2?:            string;
    name3?:            string;
    phone?:            string;
    email?:            string;
    sourceDb?:         string;
    reference?:        string;
    personFolderType?: string;
}

export function toEmployeeXml(employee: Employee): string {
    var xml = '';
    xml += SoapUtils.makeNode(employee.id, 'id');
    xml += SoapUtils.makeNode(employee.contact, 'contact');
    xml += SoapUtils.makeNode(employee.company, 'company');
    xml += SoapUtils.makeNode(employee.department, 'department');
    xml += SoapUtils.makeNode(employee.departmentInfo, 'departmentInfo');
    xml += SoapUtils.makeNode(employee.position, 'position');
    xml += SoapUtils.makeNode(employee.positionInfo, 'positionInfo');
    xml += SoapUtils.makeNode(employee.isPrimary, 'isPrimary');
    xml += SoapUtils.makeNode(employee.validFrom, 'validFrom');
    xml += SoapUtils.makeNode(employee.validTo, 'validTo');
    xml += SoapUtils.makeNode(employee.type, 'type');
    xml += SoapUtils.makeNode(employee.originalName, 'originalName');
    xml += SoapUtils.makeNode(employee.custom1, 'custom1');
    xml += SoapUtils.makeNode(employee.custom2, 'custom2');
    xml += SoapUtils.makeNode(employee.custom3, 'custom3');   
    xml += SoapUtils.makeNode(employee.positionName, 'positionName');
    xml += SoapUtils.makeNode(employee.departmentName, 'departmentName');
    xml += SoapUtils.makeNode(employee.name1, 'name1');
    xml += SoapUtils.makeNode(employee.name2, 'name2');
    xml += SoapUtils.makeNode(employee.name3, 'name3');
    xml += SoapUtils.makeNode(employee.phone, 'phone');
    xml += SoapUtils.makeNode(employee.email, 'email');
    xml += SoapUtils.makeNode(employee.sourceDb, 'sourceDb');
    xml += SoapUtils.makeNode(employee.reference, 'reference');
    xml += SoapUtils.makeNode(employee.personFolderType, 'personFolderType');
    return `<EMPLOYEE>${xml}</EMPLOYEE>`;
}   

